import { render, staticRenderFns } from "./LifeskillItem.vue?vue&type=template&id=09b73006&scoped=true&"
import script from "./LifeskillItem.vue?vue&type=script&lang=js&"
export * from "./LifeskillItem.vue?vue&type=script&lang=js&"
import style0 from "./LifeskillItem.vue?vue&type=style&index=0&id=09b73006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b73006",
  null
  
)

export default component.exports